import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref } from "vue";
const _hoisted_1 = ["src"];
const _hoisted_2 = ["src"];
const _hoisted_3 = ["src"];
const _hoisted_4 = ["src"];
import { computed } from 'vue';
import { GOOGLE_DRIVE, MIME_TYPES, PRIVATE_SYSTEM_FOLDER, } from '../util/const_helper';
import AudioPrivateIcon from '../assets/img/audio-lock.svg';
import CsvPrivateIcon from '../assets/img/csv-lock.svg';
import DocsPrivateIcon from '../assets/img/docs-lock.svg';
import PptPrivateIcon from '../assets/img/ppt-lock.svg';
import ExcelPrivateIcon from '../assets/img/excel-lock.svg';
import VideoPrivateIcon from '../assets/img/video-lock.svg';
import VideoEncodedPrivateIcon from '../assets/img/video-encoded-lock.svg';
import TextPrivateIcon from '../assets/img/txt-lock.svg';
import PdfPrivateIcon from '../assets/img/pdf-lock.svg';
import ZipPrivateIcon from '../assets/img/zip-lock.svg';
import ImagePrivateIcon from '../assets/img/image-lock.svg';
import TtfIcon from '../assets/img/ttf.svg';
import OtfIcon from '../assets/img/otf.svg';
import WoffIcon from '../assets/img/woff.svg';
import Woff2Icon from '../assets/img/woff2.svg';
import AudioIcon from '../assets/img/audio-2.svg';
import CsvIcon from '../assets/img/csv.svg';
import DocsIcon from '../assets/img/docs-2.svg';
import PptIcon from '../assets/img/ppt.svg';
import ExcelIcon from '../assets/img/excel-2.svg';
import VideoEncodedIcon from '../assets/img/video-encoded.svg';
import VideoIcon from '../assets/img/video.svg';
import TextIcon from '../assets/img/text-2.svg';
import PdfIcon from '../assets/img/pdf-2.svg';
import ZipIcon from '../assets/img/zip.svg';
import TtfPrivateIcon from '../assets/img/ttf-lock.svg';
import OtfPrivateIcon from '../assets/img/otf-lock.svg';
import WoffPrivateIcon from '../assets/img/woff-lock.svg';
import Woff2PrivateIcon from '../assets/img/woff2-lock.svg';
import { useStore } from '@/store';
export default /*#__PURE__*/ _defineComponent({
    __name: 'TableImage',
    props: {
        file: {},
        type: {}
    },
    setup(__props) {
        const props = __props;
        const state = useStore();
        function generateCDNLink(url) {
            return `https://images-staging.leadconnectorhq.com/image/f_webp/q_80/r_50/u_${url}`;
        }
        const fileType = computed(() => {
            for (const [type, mimeTypes] of Object.entries(MIME_TYPES)) {
                if (Array.isArray(mimeTypes)) {
                    if (mimeTypes.includes(props.file.contentType)) {
                        return type;
                    }
                }
                else {
                    for (const [subType, subMimeTypes] of Object.entries(mimeTypes)) {
                        if (subMimeTypes.includes(props.file.contentType)) {
                            return subType;
                        }
                    }
                }
            }
            return 'other';
        });
        function getImageLink(file) {
            if (state.activeCategory.includes(GOOGLE_DRIVE))
                return file.url;
            if (props.type === 'file' || props.type === 'static') {
                return generateCDNLink(file.url);
            }
            else if (props.type === 'pixabay') {
                return generateCDNLink(file.previewURL);
            }
            else if (props.type === 'unsplash') {
                return generateCDNLink(file.urls.regular);
            }
        }
        const selfHosted = computed(() => {
            return state.selfHosted;
        });
        const isEncoded = computed(() => {
            return props.file.isEncoded;
        });
        const getThumbnail = computed(() => {
            const { contentType, isPrivate, category, subCategory } = props.file;
            const isPrivateSystemFolder = PRIVATE_SYSTEM_FOLDER.includes(category) ||
                PRIVATE_SYSTEM_FOLDER.includes(`${category}_${subCategory}`);
            const privateMode = isPrivate || isPrivateSystemFolder;
            let icon;
            switch (true) {
                case contentType.startsWith('image') && privateMode:
                    icon = ImagePrivateIcon;
                    break;
                case MIME_TYPES['documents']['pdf'].includes(contentType):
                    icon = privateMode ? PdfPrivateIcon : PdfIcon;
                    break;
                case MIME_TYPES['documents']['excel'].includes(contentType):
                    icon = privateMode ? ExcelPrivateIcon : ExcelIcon;
                    break;
                case MIME_TYPES['documents']['doc'].includes(contentType):
                    icon = privateMode ? DocsPrivateIcon : DocsIcon;
                    break;
                case MIME_TYPES['documents']['ppt'].includes(contentType):
                    icon = privateMode ? PptPrivateIcon : PptIcon;
                    break;
                case MIME_TYPES['documents']['text'].includes(contentType):
                    icon = privateMode ? TextPrivateIcon : TextIcon;
                    break;
                case MIME_TYPES['audio'].includes(contentType):
                    icon = privateMode ? AudioPrivateIcon : AudioIcon;
                    break;
                case MIME_TYPES['video'].includes(contentType) &&
                    selfHosted.value &&
                    isEncoded.value:
                    icon = privateMode ? VideoEncodedPrivateIcon : VideoEncodedIcon;
                    break;
                case MIME_TYPES['video'].includes(contentType):
                    icon = privateMode ? VideoPrivateIcon : VideoIcon;
                    break;
                case MIME_TYPES['zip'].includes(contentType):
                    icon = privateMode ? ZipPrivateIcon : ZipIcon;
                    break;
                case MIME_TYPES['documents']['csv'].includes(contentType):
                    icon = privateMode ? CsvPrivateIcon : CsvIcon;
                    break;
                case contentType === 'font/ttf':
                    icon = isPrivate ? TtfPrivateIcon : TtfIcon;
                    break;
                case contentType === 'font/otf':
                    icon = isPrivate ? OtfPrivateIcon : OtfIcon;
                    break;
                case contentType === 'font/woff' || contentType === 'application/font-woff':
                    icon = isPrivate ? WoffPrivateIcon : WoffIcon;
                    break;
                case contentType === 'font/woff2':
                    icon = isPrivate ? Woff2PrivateIcon : Woff2Icon;
                    break;
                default:
                    icon = ''; // fallback for unsupported file types
                    break;
            }
            return icon;
        });
        return (_ctx, _cache) => {
            return (['pixabay', 'unsplash'].includes(_ctx.type))
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    class: "w-[50px] h-[50px]",
                    src: getImageLink(_ctx.file),
                    alt: "file"
                }, null, 8 /* PROPS */, _hoisted_1))
                : (['static'].includes(_ctx.type))
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 1,
                        class: "w-[50px] h-[50px]",
                        src: getImageLink(_ctx.file),
                        alt: "file"
                    }, null, 8 /* PROPS */, _hoisted_2))
                    : (!_ctx.file.isPrivate &&
                        !_unref(PRIVATE_SYSTEM_FOLDER).includes(_ctx.file.category) &&
                        !_unref(PRIVATE_SYSTEM_FOLDER).includes(`${_ctx.file.category}_${_ctx.file.subCategory}`) &&
                        ['file'].includes(_ctx.type) &&
                        fileType.value === 'image')
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 2,
                            class: "w-[50px] h-[50px]",
                            src: getImageLink(_ctx.file),
                            alt: "file"
                        }, null, 8 /* PROPS */, _hoisted_3))
                        : (_openBlock(), _createElementBlock("img", {
                            key: 3,
                            src: getThumbnail.value,
                            class: "w-[50px] h-[50px]"
                        }, null, 8 /* PROPS */, _hoisted_4));
        };
    }
});
